export const FETCH_PORTFOLIOTREEOFFAMILYCS_BEGIN="FETCH_PORTFOLIOTREEOFFAMILYCS_BEGIN";
export const FETCH_PORTFOLIOTREEOFFAMILYCS_SUCCESS="FETCH_PORTFOLIOTREEOFFAMILYCS_SUCCESS";
export const FETCH_PORTFOLIOTREEOFFAMILYCS_FAILURE="FETCH_PORTFOLIOTREEOFFAMILYCS_FAILURE";

export const FETCH_PORTFOLIOFAMILY_BEGIN="FETCH_PORTFOLIOFAMILY_BEGIN";
export const FETCH_PORTFOLIOFAMILY_SUCCESS="FETCH_PORTFOLIOFAMILY_SUCCESS";
export const FETCH_PORTFOLIOFAMILY_FAILURE="FETCH_PORTFOLIOFAMILY_FAILURE";

export const FETCH_PORTFOLIOCS_BEGIN="FETCH_PORTFOLIOCS_BEGIN";
export const FETCH_PORTFOLIOCS_SUCCESS="FETCH_PORTFOLIOCS_SUCCESS";
export const FETCH_PORTFOLIOCS_FAILURE="FETCH_PORTFOLIOCS_FAILURE";
